import {useState} from "react";

const ImgWithFallback = ({src, fallbackSrc, alt, title, width, height}) => {
    const [currentSrc, setCurrentSrc] = useState(src);

    return (
        <img
            src={currentSrc}
            alt={alt}
            title={title}
            width={width}
            height={height}
            onError={() => setCurrentSrc(fallbackSrc)}
            loading="lazy"
        />
    );
}

export default ImgWithFallback;